import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export function Shell({ children, header, className = "" }) {
  return (
    <div className="min-h-screen w-full flex justify-center bg-[#EDEBE5]">
      <div className="relative w-full max-w-md min-h-screen bg-background flex flex-col shadow-[0_0_60px_rgba(0,0,0,0.08)]">
        {header}
        <main className={`flex-1 flex flex-col ${className}`}>{children}</main>
      </div>
    </div>
  );
}

export function TopBar({ title, onBack, right }) {
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 z-30 bg-background/95 backdrop-blur border-b border-border">
      <div className="h-14 px-3 flex items-center gap-2">
        <button
          data-testid="topbar-back"
          onClick={() => (onBack ? onBack() : navigate(-1))}
          className="tap p-2 rounded-full hover:bg-secondary"
          aria-label="Back"
        >
          <ArrowLeft className="w-5 h-5" />
        </button>
        <h1 className="font-head font-semibold text-base truncate">{title}</h1>
        <div className="ml-auto">{right}</div>
      </div>
    </header>
  );
}

export function Disclaimer({ children, testId = "disclaimer", tone = "muted" }) {
  const styles =
    tone === "amber"
      ? "border-[#F0C58A] bg-[#FDF6EC] text-[#8A5A12]"
      : "border-border bg-secondary/70 text-muted-foreground";
  return (
    <div
      data-testid={testId}
      className={`flex gap-2.5 rounded-2xl border px-4 py-3 text-[12.5px] leading-relaxed ${styles}`}
    >
      <span className="mt-0.5 shrink-0 w-4 h-4 rounded-full border-2 border-current flex items-center justify-center text-[10px] font-bold">i</span>
      <p>{children}</p>
    </div>
  );
}
